import { render, staticRenderFns } from "./EntitlementDetail.vue?vue&type=template&id=2ab2a252&"
import script from "./EntitlementDetail.vue?vue&type=script&lang=js&"
export * from "./EntitlementDetail.vue?vue&type=script&lang=js&"
import style0 from "./EntitlementDetail.vue?vue&type=style&index=0&id=2ab2a252&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports